import pagesWrapper from "/pagesSrrLogic/pagesWrapper";
import { SITE_PAGE_TYPE } from "/pagesSrrLogic/sitePageType";
import LayoutWrapper from "~/components/layouts/layoutWrapper";
import { Api } from "~/api";
import { setTextCity } from "@/utils";
import { wrapper } from "../../redux";
import { addBreadcrumb } from "../../redux/action-creaters/breadcrumbs";
import { fetchBrand } from "../../redux/action-creaters/brands";
import Detail from "/components/pages/brands/detail";
import Redis from "/lib/redis";
import { setDescription, setTitle } from "/redux/action-creaters/meta";
import { sspWrapper } from "../../utils/errors/sspWrapper";

export default function BrandsDetailPage({ brand, scripts, host }) {
  return (
    <LayoutWrapper scripts={scripts} isIndex={false} host={host}>
      <Detail brand={brand} />
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  sspWrapper(async ({ params, query, req, resolvedUrl }) => {
    const reset = Boolean(query.reset);
    await store.dispatch(await fetchBrand(Redis, params.code, reset));
    store.dispatch(addBreadcrumb({ link: "/brands/", name: "Бренды" }));

    const { brands } = store.getState();
    if (!brands.detail.name) {
      return {
        redirect: {
          destination: "/brands/",
          statusCode: 301,
        },
      };
    }
    const brand = brands.detail;
    store.dispatch(
      addBreadcrumb({ link: `/brands/${brand.code}`, name: brand.name }),
    );

    const domains = await Api.server.getDomains(Boolean(query.reset));
    Object.keys(brand.meta).forEach((key) => {
      brand.meta[key] = setTextCity(
        req.headers["host-proxy"] || req.headers.host,
        domains,
        brand.meta[key],
      );
    });
    store.dispatch(setTitle(brand.meta?.title ?? brand.name));
    store.dispatch(setDescription(brand.meta?.description ?? brand.name));

    return pagesWrapper(
      {
        pageType: SITE_PAGE_TYPE.brandDetail,
        brand,
      },
      store,
      Redis,
      {
        query,
        req,
        resolvedUrl,
      },
      "/brands/",
      false,
    );
  }),
);
